var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 950.9 660.6",
    style: {
      enableBackground: "new 0 0 950.9 660.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M806.2,495c-87.4-33.1-115.4-61-115.4-120.7c0-35.9,26.7-24.1,38.4-89.8c4.8-27.3,28.4-0.4,32.9-62.7 c0-24.8-12.9-30.9-12.9-30.9s6.5-36.7,9.1-64.9C761.5,90.8,738.7,0,617.4,0S473.3,90.9,476.5,126c2.5,28.2,9.1,64.9,9.1,64.9 s-12.8,6.2-12.8,30.9c4.5,62.2,28,35.4,32.9,62.7c11.7,65.7,38.4,53.9,38.4,89.8c0,59.7-27.1,87.6-114.5,120.7 c-87.7,33.1-143.8,67-143.8,90s0,75.6,0,75.6h665.1c0,0,0-52.5,0-75.6C950.9,562,893.9,528.1,806.2,495L806.2,495z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,176.4h417.3c-2.1-13.4-4.4-30.5-5.8-45.8c-1.6-17.5,0.7-37.6,6.4-57H0V176.4L0,176.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,587.5h220.6V585c0-41.6,36.5-69,63.9-86c7.6-4.7,16-9.5,25.1-14.3H0V587.5L0,587.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,382h478.6c0.1-1.5-35.6-46-45.3-102.8H0V382L0,382z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUser);
export default __webpack_public_path__ + "static/media/menu-user.70b9b504843d49e75074f61ce4a7a81a.svg";
export { ForwardRef as ReactComponent };